export { default } from "./pill";
export type { PillProps } from "./pill";
